import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
    INIT: 'INIT',
}

export const importSpreadsheetEventBroker = new EventBroker();
